import { observable, action, computed, toJS, reaction, extendObservable } from "mobx";
import {arrayToString, deleteByAtribute, getByAtribute, stringToArray} from "../../../utils/formatar";
import UsuarioService from "../../../services/UsuarioService";
import EmpregadoService from "../../../services/EmpregadoService";
import _ from "lodash";

export default class UsuarioStore {

    @observable usuarioLista;
    @observable itemSelecionado;
    @observable usuarios;
    @observable loading;
    @observable gestoresFiltrados;
    @observable gestoresSelecionados;
    @observable ghsSelecionadas;
    @observable posicoesSelecionadas;
    @observable empregadosFiltrados;

    constructor(modalStore) {
        this.modalStore = modalStore;
        this.usuarioLista = [];
        this.resetItemSelecionado();
        this.gestoresFiltrados = [];
        this.empregadoService = new EmpregadoService();
        this.usuarioService = new UsuarioService();
        this.gestorSelecionado = null;
        this.ghsSelecionadas = [];
        this.posicoesSelecionadas = [];
        this.empregadosFiltrados = [];

        this.filtrarUsuarios = _.debounce(this._filtrarUsuariosPorNome, 1000);
        this.filtrarGestores = _.debounce(this._filtrarGestores, 1000);
        this.filtrarEmpregados = _.debounce(this._filtrarEmpregados, 1000);
        this.filtrarEmpregadosByMatricula = _.debounce(this._filtrarEmpregadosByMatricula, 1000);
    }

    @computed
    get apenasMatriculaGestoresPermitidos() {
        const matriculasValidas = [];
        const matriculas = this.itemSelecionado.matriculas ? this.itemSelecionado.matriculas.split(",") : [];

        matriculas.map(empregado => {
            if(empregado && typeof empregado === "object") {
                matriculasValidas.push(empregado.value);
            } else if(empregado && empregado.length === 11){
                matriculasValidas.push(getByAtribute(this.gestoresFiltrados, empregado, "cpf").matricula);
            } else if(empregado) {
                matriculasValidas.push(empregado);
            }
        });
        return matriculasValidas;
    }

    @computed
    get gestoresPermitidosCompletos() {
        return this.apenasMatriculaGestoresPermitidos.map(matricula => {
            let getByMatricula = getByAtribute(this.gestoresFiltrados, matricula, "matricula");
            if (!getByMatricula) {
                getByMatricula = this.itemSelecionado.solicitantesMotUsuario ? toJS(getByAtribute(this.itemSelecionado.solicitantesMotUsuario, matricula, "matricula")) : [];
            }
            getByMatricula.gestor = getByMatricula.nh !== 'EQUIPE' && getByMatricula.nh !== 'EQUIPE TECNICO OPERACIONAL';
            return getByMatricula;
        });
    }

    resetItemSelecionado() {
        this.itemSelecionado = {
            id: 0,
            login: "",
            matriculas: "",
            empregadoCPFs: "",
            perfilExecutivo: false,
            perfilAdministrador: false,
            perfilDcch: false,
            perfilDnc: false,
            perfilRemuneracao: false,
            perfilRts: false,
            perfilSolicitanteMot: false,
            perfilRelatorioFinanceiro: false,
            perfilRelatorioTimesheet: false,
            perfilRelatorioMOTsAtivas: false,
            perfilRelatorioSISMOT: false,
            notificacaoTimesheetD1: false,
            notificacaoTimesheetD2: false,
            notificacaoTimesheetD3: false
        };
    }

    togglePerfilAdministrador() {
        this.itemSelecionado.perfilAdministrador = !this.itemSelecionado.perfilAdministrador
    }

    togglePerfilDCCH() {
        this.itemSelecionado.perfilDcch = !this.itemSelecionado.perfilDcch
    }

    togglePerfilDNC() {
        this.itemSelecionado.perfilDnc = !this.itemSelecionado.perfilDnc
    }

    togglePerfilRemuneracao() {
        this.itemSelecionado.perfilRemuneracao = !this.itemSelecionado.perfilRemuneracao
    }

    togglePerfilRTS() {
        this.itemSelecionado.perfilRts = !this.itemSelecionado.perfilRts
    }

    togglePerfilSolicitanteMOT() {
        this.itemSelecionado.perfilSolicitanteMot = !this.itemSelecionado.perfilSolicitanteMot;
    }

    togglePerfilRelatorioFinanceiro() {
        this.itemSelecionado.perfilRelatorioFinanceiro = !this.itemSelecionado.perfilRelatorioFinanceiro;
    }

    togglePerfilRelatorioMOTsAtivas() {
        this.itemSelecionado.perfilRelatorioMOTsAtivas = !this.itemSelecionado.perfilRelatorioMOTsAtivas;
    }

    togglePerfilRelatorioTimesheet() {
        this.itemSelecionado.perfilRelatorioTimesheet = !this.itemSelecionado.perfilRelatorioTimesheet;
    }

    toggleNotificacaoTimesheetD3() {
        this.itemSelecionado.notificacaoTimesheetD3 = !this.itemSelecionado.notificacaoTimesheetD3;
    }

    toggleNotificacaoTimesheetD2() {
        this.itemSelecionado.notificacaoTimesheetD2 = !this.itemSelecionado.notificacaoTimesheetD2;
    }

    toggleNotificacaoTimesheetD1() {
        this.itemSelecionado.notificacaoTimesheetD1 = !this.itemSelecionado.notificacaoTimesheetD1;
    }
    //RHFPP-612 - Relatorio Sis MOT
    togglePerfilRelatorioSISMOT() {
        this.itemSelecionado.perfilRelatorioSISMOT = !this.itemSelecionado.perfilRelatorioSISMOT;
    }

    setEmpregadoByMatricula(value) {
        this.alerta = "";
        let newDisplay = value;
        let retirados = this.getDiferenca(this.itemSelecionado.empregadoCPFs, value, true);
        let adicionados = this.getDiferenca(this.itemSelecionado.empregadoCPFs,value, false);

        if(retirados.length > 0){
            this.atualizaGhsProCpf(retirados, true);
        }

        if(adicionados.length > 0){
            this.atualizaGhsProCpf(adicionados, false);

            if(this.alerta.length > 0){
                let values = value.split(",");
                newDisplay = "";
                values.map((valor) => {
                    if(valor != adicionados[0]){
                        newDisplay = newDisplay.length > 0 ? newDisplay + "," + valor : valor;
                    }
                });
            }
        }

        this.itemSelecionado.empregadoCPFs = newDisplay;
    }

    getDiferenca(cpfAntigos, cpfNovos, isRetirada){
        let cpfA = [];
        if(cpfAntigos != undefined && cpfAntigos.length > 0){
            cpfA =  cpfAntigos.split(',');
        }

        let cpfN = [];
        if(cpfNovos != undefined && cpfNovos.length > 0){
            cpfN = cpfNovos.split(',');
        }


        let diferenca = [];

        if(isRetirada){
            cpfA.map( value => {
                if(cpfN.indexOf(value) == -1){
                    diferenca.push(value);
                }
            })
        }
        else{
            cpfN.map( value => {
                if(cpfA.length == 0 || cpfA.indexOf(value) == -1){
                    diferenca.push(value);
                }
            })
        }
        return diferenca;
    }

    atualizaGhsProCpf(listaParaAtualiza, isRetirada){
        listaParaAtualiza.map(valorCpfOuMatricula => {
            let empregado = null;
            if(valorCpfOuMatricula.length > 9) {
                empregado = this.empregadosFiltrados.filter(emp => emp.cpf == valorCpfOuMatricula);
            } else {
                empregado = this.empregadosFiltrados.filter(emp => emp.matricula && emp.matricula.toString() == valorCpfOuMatricula);
            }

            if(empregado && empregado.length > 0){

                if(isRetirada && this.posicoesSelecionadas.length > 0){
                    this.posicoesSelecionadas = this.posicoesSelecionadas.filter(posicao => posicao != empregado[0].posicao);
                }
                else{
                    if(this.posicoesSelecionadas.filter(posicao => posicao === empregado[0].posicao).length == 0){
                        if(["Equipe", "Técnico/Operacional"].indexOf(empregado[0].nh) !== -1){
                            this.alerta = "Só é possivel associar GHs de gestores";
                        }
                        else {
                            this.posicoesSelecionadas.push(empregado[0].posicao);
                        }
                    }
                }
            }
        });

    }

    removePosicaoValue(value){
        this.posicoesSelecionadas = this.posicoesSelecionadas.filter(posicao => posicao !== value);

        if(this.itemSelecionado.empregadoCPFs && this.itemSelecionado.empregadoCPFs.length > 0){
            let empregado =  this.empregadosFiltrados.filter(emp => emp.codigoGH === value);
            let cpfsOuMatricula = this.itemSelecionado.empregadoCPFs.split(',');
            empregado.map(emp => {
                if(emp.cpf != null) {
                    cpfsOuMatricula = cpfsOuMatricula.filter(cpf => cpf != emp.cpf);
                } else {
                    cpfsOuMatricula = cpfsOuMatricula.filter(matricula => matricula != emp.matricula);
                }
            });
            this.itemSelecionado.empregadoCPFs = "";
            cpfsOuMatricula.map( valor => {
                this.itemSelecionado.empregadoCPFs = this.itemSelecionado.empregadoCPFs.length > 0 ?  this.itemSelecionado.empregadoCPFs +","+ valor: valor;
            });
        }
        else{
            this.itemSelecionado.empregadoCPFs = "";
            this.empregadosFiltrados =  [];
        }
    }

    carregarLista() {
        this.loading = true;

        const loadingPromises = Promise.all([

            this.usuarioService.list().then(response => {
                this.usuarioLista = response.data;
            }).catch(error => {
                console.log(error);
            })
        ]);
        loadingPromises.then(
            () => {
                this.loading = false;
            }
        ).catch(
            (error) => this.loading = false
        )
    }

    setLogin(value) {
        this.itemSelecionado.login = value;
    }

    _filtrarUsuariosPorNome(input, callback) {
        let result = [];
        if(input && input.length > 1) {
            this.usuarioService.filterByName(input).then(response => {
                if(response.data) {
                    response.data.map(usuario => {
                        result.push({value: usuario.login, label: usuario.nome});
                    });
                }
                callback(null, {
                    options: result,
                    complete: false
                });
            }).catch(error => {
                callback(null, {
                    options: result,
                    complete: false
                });
                console.log(error);
            });
        } else {
            callback(null, {
                options: result,
                complete: false
            });
        }
    }


    _filtrarEmpregados(input, callback) {
        const result = [];
        if(input && input.length > 1) {
            this.empregadoService.getByCPFOrMatricula(input, callback).then(response => {
                let gestores = (response && response.length > 0) ? response.filter(g => g.cargo.nh !== 'EQUIPE' && g.cargo.nh !== 'EQUIPE TECNICO OPERACIONAL') : null;
                if (gestores && gestores !== null) {
                    this.gestoresFiltrados = _.uniqBy(this.gestoresFiltrados.concat(gestores), "matricula");
                }
                callback(null, {
                    options: gestores.map(empregado => {
                        const cpf = !!empregado.cpf ? " (" + empregado.cpf + ")" : "";
                        return {value: empregado.matricula, label: empregado.matricula + " - " + empregado.nome + cpf, gestor: empregado.gestor};
                    }),
                    complete: false
                });
            }).catch(error => {
                callback(null, {
                    options: [],
                    complete: false
                });
            });
        } else {
            callback(null, {
                options: result,
                complete: false
            });
        }
    }

    _filtrarEmpregadosByMatricula(input, callback) {
        const empregadosSelecionadosValores = this.itemSelecionado.empregadoCPFs
            ? this.itemSelecionado.empregadoCPFs.split(',').filter(v => v.trim())
            : [];

        const opcoesSelecionadas = this.empregadosFiltrados
            .filter(emp => {
                const valor = emp.cpf && emp.cpf.length > 9 ? emp.cpf : (emp.matricula ? emp.matricula.toString() : "");
                return empregadosSelecionadosValores.includes(valor);
            })
            .map(empregado => {
                let valor = "";
                let displayName = "";

                if(empregado.matricula != null && empregado.matricula.toString().length > 0){
                    valor = empregado.matricula.toString();
                    displayName = empregado.matricula.toString() + " - " + empregado.nome;
                }
                else if(empregado.cpf != null && empregado.cpf.length > 0){
                    valor = empregado.cpf;
                    displayName = displayName.length > 0 ? displayName + " " + valor : empregado.nome + " - " + valor;
                }

                return valor.length > 0 ? {value: valor, label: displayName} : null;
            })
            .filter(opt => opt !== null);

        if(input && input.length > 1) {
            this.empregadoService.getByCPFOrMatricula(input, callback).then(response => {
                if(response && response.length > 0) {
                    this.empregadosFiltrados.push(...response);
                }

                const opcoesBusca = response.map(empregado => {
                    let valor = "";
                    let displayName = "";

                    if(empregado.matricula != null && empregado.matricula.toString().length > 0){
                        valor = empregado.matricula.toString();
                        displayName = empregado.matricula.toString() + " - " + empregado.nome;
                    }
                    else if(empregado.cpf != null && empregado.cpf.length > 0){
                        valor = empregado.cpf;
                        displayName = displayName.length > 0 ? displayName + " " + valor : empregado.nome + " - " + valor;
                    }

                    return valor.length > 0 ? {value: valor, label: displayName} : null;
                }).filter(opt => opt !== null);

                callback(null, {
                    options: _.uniqBy(opcoesSelecionadas.concat(opcoesBusca), "value"),
                    complete: false
                });
            }).catch(error => {
                callback(null, {
                    options: opcoesSelecionadas,
                    complete: false
                });
            });
        } else {
            callback(null, {
                options: opcoesSelecionadas,
                complete: false
            });
        }
    }

    toggleAtivo() {
        this.itemSelecionado.ativo = !this.itemSelecionado.ativo;
    }

    setUsuarioLogin(value) {
        this.itemSelecionado.login = value;
    }

    setGestoresPermitidos(item) {
        this.itemSelecionado.matriculas = item;
    }

    setTipo(value) {
        this.itemSelecionado.tipo = value;
    }

    setLista(value) {
        this.usuarioLista = value;
    }


    preencherModal(row){
        if(row) {
            if(row.solicitantesMotUsuario && row.solicitantesMotUsuario.length > 0) {
                row.matriculas = arrayToString(row.solicitantesMotUsuario, "matricula", true);
            } else {
                row.matriculas = "";
            }
            row.empregadoCPFs = "";
            this.itemSelecionado = Object.assign({}, row);
            this.posicoesSelecionadas = row.ghRelFinanceiro != null && row.ghRelFinanceiro.length > 0 ? row.ghRelFinanceiro : (row.ghRelTimesheet != null && row.ghRelTimesheet.length ? row.ghRelTimesheet : row.ghRelMOTsAtivas);
        } else {
            this.resetItemSelecionado();
        }
    }

    editar() {
        let tabelaIndex = this.usuarioLista.findIndex((tabelaItem) => tabelaItem.id === this.itemSelecionado.id);
        if(!this.itemSelecionado.perfilSolicitanteMot) { this.itemSelecionado.solicitantesMotUsuario = [] }

        const form = Object.assign({}, this.itemSelecionado);
        form.matriculasSolicitantesMotUsuario = this.apenasMatriculaGestoresPermitidos;
        form.ghsSelecionadasFrontend = this.posicoesSelecionadas;
        form.permissoesUsuario = null;

        return this.usuarioService.edit(form.id, form).then(response => {
            this.usuarioLista[tabelaIndex] = response.data;
        })
    }

    cadastrar() {
        const form = Object.assign({}, this.itemSelecionado);

        form.matriculasSolicitantesMotUsuario = this.apenasMatriculaGestoresPermitidos;
        form.ghsSelecionadasFrontend = this.posicoesSelecionadas;
        form.permissoesUsuario = null;

        return this.usuarioService.save(form).then(response => {
            this.usuarioLista.push(response.data);
        });

    }

    remover() {
        let tabelaIndex = this.usuarioLista.findIndex((tabelaItem) => tabelaItem.id === this.itemSelecionado.id);

        let modal = this.modalStore;

        return this.usuarioService.delete(this.itemSelecionado.id).then(response => {
            this.usuarioLista.splice(tabelaIndex, 1);
            modal.toggleModal()
        }).catch(error => {
            modal.setSubmitMensagemErro(error.response.data.message)
        })
    }

    _filtrarGestores(input, callback) {
        const opcoesSelecionadas = (this.itemSelecionado.solicitantesMotUsuario || []).map(empregado => ({
            value: empregado.matricula,
            label: empregado.nome + " (" + empregado.matricula + ")",
            gestor: empregado.gestor
        }));

        if(input && input.length > 2) {
            this.empregadoService.getByCPFOrMatricula(input, callback).then(response => {
                const gestores = (response && response.length > 0)
                    ? response.filter(g => g.cargo.nh !== 'EQUIPE' && g.cargo.nh !== 'EQUIPE TECNICO OPERACIONAL')
                    : [];

                if (gestores.length > 0) {
                    this.gestoresFiltrados = _.uniqBy(this.gestoresFiltrados.concat(gestores), "matricula");
                }

                const opcoesBusca = gestores.map(empregado => {
                    return {value: empregado.matricula, label: empregado.nome + " (" + empregado.matricula + ")", gestor: empregado.gestor};
                });

                callback(null, {
                    options: _.uniqBy(opcoesSelecionadas.concat(opcoesBusca), "value"),
                    complete: false
                });
            }).catch(error => {
                callback(null, {
                    options: opcoesSelecionadas,
                    complete: false
                });
            });
        } else {
            callback(null, {
                options: opcoesSelecionadas,
                complete: false
            });
        }
    }

}